"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _react = _interopRequireDefault(require("react"));
var _MenuDropdownButton = _interopRequireDefault(require("./MenuDropdownButton.styles"));
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MenuDropdownButton = function MenuDropdownButton(_ref) {
  var userAccount = _ref.userAccount,
    buttonTitle = _ref.buttonTitle,
    handleClick = _ref.handleClick,
    buttonProps = _ref.buttonProps,
    menuIconProps = _ref.menuIconProps,
    hideIcon = _ref.hideIcon;
  var classes = (0, _MenuDropdownButton["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    classes: {
      label: classes.viewButtonLabel
    },
    className: classes.menuButton,
    "aria-controls": "menu",
    "aria-haspopup": "true",
    onClick: handleClick
  }, buttonProps), buttonTitle, userAccount && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.spacer
  }, "|"), userAccount), !hideIcon && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
    size: "1x",
    className: classes.buttonIcon,
    icon: _proSolidSvgIcons.faCaretDown
  }, menuIconProps)));
};
var _default = MenuDropdownButton;
exports["default"] = _default;